import { render } from "./PictureDetail.vue?vue&type=template&id=d6760fe0"
import script from "./PictureDetail.vue?vue&type=script&lang=js"
export * from "./PictureDetail.vue?vue&type=script&lang=js"

import "./PictureDetail.vue?vue&type=style&index=0&id=d6760fe0&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__